<div class="overlay" *ngIf="overlay">
    <div [ngClass]="language == 1 ? 'centerAr' : 'center'">
        <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
</div>